import { QRFC } from "./QRFC";

export class QGreenhouseTokenRFC extends QRFC {
  constructor() {
    super();
  }

  InitRFC() {
    this.InitRemoteCall(null, "POST", true, false);
  }

  GetCallName() {
    return "Endpoints/qgreenhousetoken";
  }

  // Sent explicitly because QRFC only adds iv/sk/zc: the endpoint releases the token pair
  // only to the account that started the authorization.
  SetParams(orgName, userName, state) {
    this.AddParameter("org", orgName);
    this.AddParameter("user", userName);
    this.AddParameter("state", state);
  }
}
